import { RouterProvider } from "react-router-dom";
import Theme from "@/components/template/Theme";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import OrganisationAllRoutes from "@/OrganisationAllRoutes";

const queryClient = new QueryClient();

function App() {
  return (
    <Theme>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={OrganisationAllRoutes} />
      </QueryClientProvider>
    </Theme>
  );
}

export default App;
